var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33301 23.3333H25.6663M10.4997 23.3333L23.333 23.3333V16.7627C23.333 16.1498 23.333 15.8433 23.2595 15.5574C23.1944 15.3041 23.087 15.0636 22.942 14.8458C22.7785 14.6001 22.5508 14.3951 22.0948 13.9855L19.4115 11.5748C18.5295 10.7824 18.0883 10.3862 17.5897 10.236C17.1505 10.1036 16.682 10.1036 16.2428 10.236C15.7442 10.3862 15.3035 10.7824 14.4215 11.5748L11.7381 13.9855C11.2822 14.3951 11.054 14.6001 10.8905 14.8458C10.7455 15.0636 10.6383 15.3041 10.5732 15.5574C10.4997 15.8433 10.4997 16.1498 10.4997 16.7627V23.3333ZM10.4997 23.3333H4.66634V8.39993C4.66634 7.09314 4.66634 6.43983 4.92066 5.9407C5.14436 5.50166 5.50106 5.14468 5.9401 4.92097C6.43923 4.66666 7.09311 4.66666 8.3999 4.66666H10.2666C11.5734 4.66666 12.2263 4.66666 12.7254 4.92097C13.1645 5.14468 13.5219 5.50166 13.7456 5.9407C13.9999 6.43983 13.9997 7.09314 13.9997 8.39993V11.6666",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.371ea0722e8a6b4e64b2ea1f3cc8055d.svg";
export { ForwardRef as ReactComponent };